import { render, staticRenderFns } from "./TemplateItemCMMF.vue?vue&type=template&id=11ffa87a&scoped=true&"
import script from "./TemplateItemCMMF.vue?vue&type=script&lang=ts&"
export * from "./TemplateItemCMMF.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateItemCMMF.vue?vue&type=style&index=0&id=11ffa87a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ffa87a",
  null
  
)

export default component.exports